<template>
 <div>
  <HeaderBg :title="$t('adminHomeStatistics.title')" />

  <div class="form_container">
    <form @submit.prevent="addStatistics">

      <!-- Loop over links -->
      <div v-for="(statistic, index) in statistics" :key="index">
        <div class="input_container">
          <label>{{$t('adminHomeStatistics.nameAr')}}</label>
          <input type="text" v-model="statistic.title_ar">
        </div>
        <div class="input_container">
          <label>{{$t('adminHomeStatistics.nameEn')}}</label>
          <input type="text" v-model="statistic.title_en">
        </div>
        <div class="input_container">
          <label>{{$t('adminHomeStatistics.value')}}</label>
          <input type="text" v-model="statistic.value">
        </div>
      
      
        <!-- Delete button for each link -->
        <button type="button" class="deleteBtn" @click="removeLink(index)">
          {{$t('adminHomeStatistics.delete')}}
        </button>
        <hr>
      </div>

      <!-- Add new link button -->
      <div>
        <button type="button" class="addMoreBtn" @click="addLink">
          {{$t('adminHomeStatistics.addStatistic')}}
        </button>
      </div>

      <!-- Success / Error messages -->
      <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
        {{$t('adminHomeStatistics.successMessage')}}
      </div>
      <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck">
        <p v-for="(error, index) in errors" :key="index"> {{ error }} </p>
      </div>

      <!-- Save Button -->
      <button class="saveBtn" v-if="!postLoaded">
        {{$t('adminHomeStatistics.save')}}
      </button>
      <button class="saveBtn" v-if="postLoaded">
        <b-spinner></b-spinner>
      </button>
    </form>
  </div>
</div>

</template>

<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import axios from 'axios';
import Request from '../../../services/Request';
export default {
  name: 'HomeStatistics',
  components: { HeaderBg },
  data() {
    return {
      postLoaded: false,
      successMessage: false,
      statistics: [
        { 
          id: '',
          title_ar: '',
          title_en: '',
          value: '',
        }
      ],
      errors: [],
      ErrorCheck: false,
    }
  },
  mounted(){
    this.getLinks();
  },
  methods: {
    addLink() {
    this.statistics.push({
      id: '',
      title_ar: '',
      title_en: '',
      value: ''
    });
  },
  removeLink(index) {
    this.statistics.splice(index, 1);
  },

    addStatistics() {
    this.successMessage = false;
    this.postLoaded = true;
    this.errors = [];
    this.ErrorCheck = false;

    // send all links
    axios.post("https://app.almujtama.com.sa/admin/statistics/home_page", {homepage:this.statistics}, {
      headers: { 
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(() => {
      this.postLoaded = false;
      this.ErrorCheck = false;
      this.successMessage = true;
    })
    .catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
        this.ErrorCheck = true;
      }
      this.postLoaded = false;
    });
  },

    getLinks() {
      Request.fetch(`admin/statistics/home_page`, '')
        .then((response) => {
          this.statistics = []
          response.data.data.forEach((item) => {
            
            this.statistics.push({
              id: item.id,
              title_ar: item.title_ar,
              title_en: item.title_en,
              value: item.value,
            });
          });
        })
        .catch(err => {
          if (Request.statusIsFaield(err)) {
            this.$router.push('/login');
            localStorage.removeItem('token');
          }
        });
    }

  }
}
</script>

<style lang="scss" scoped>
.addMoreBtn{
    border: 0;
    background-color: #656565;
    color: #FFF;
    display: inline-block;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 16px;
    margin-right: 20px;
}
.deleteBtn{
    border: 0;
    background-color: rgba(255, 0, 0, 0.667);
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 20px;
}
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px 0;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input,
            select{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-left: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>